import { IconButton, Outside } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { requestAuthentication } from '../../../../actions/authentication';
import { Dispatch } from '../../../../common/state';
import { EAlertType } from '../../../../types/microfrontends';
import { CommercialCardContext } from '../../CommercialCard/context';

import type {
  IStartChatButtonContext,
  IStartChatButtonDispatchProps,
  IStartChatButtonProps,
  IStartChatButtonState,
} from './types';

import * as styles from './StartChatPopup.css';

type TStartChatPopupProps = React.PropsWithChildren<IStartChatButtonProps & IStartChatButtonDispatchProps>;

export class StartChatPopupComponent extends PureComponent<TStartChatPopupProps, IStartChatButtonState> {
  public readonly context: IStartChatButtonContext;

  public static contextType = CommercialCardContext;

  public constructor(props: TStartChatPopupProps) {
    super(props);

    this.state = { showChats: false };
  }

  public render(): React.JSX.Element {
    const { children } = this.props;
    const { showChats } = this.state;

    return (
      <div>
        {showChats && (
          <Outside onOutside={this.handleClickOutside}>
            <div className={styles['container']}>
              <span className={styles['close']}>
                <IconButton icon={<IconActionClose16 />} onClick={this.handleClickOutside} />
              </span>
              <iframe className={styles['iframe']} src={this.chatsIframeSrc} />
            </div>
          </Outside>
        )}
        <div onClick={this.handleWriteMessageClick}>{children}</div>
      </div>
    );
  }

  private get chatsIframeSrc(): string {
    const { gaProducts, gaLabel } = this.props;

    const { offer } = this.context;
    const { id, cianId, dealType, offerType, cianUserId, contextToken } = offer;

    const companionName = this.companionName;

    const urlSearchParams = new URLSearchParams({
      hostType: 'frame',
      // Сервис чатов ищет объявление по cianId; realty id (`id`) у части объявлений отличается (CD-280945)
      offerId: (cianId ?? id).toString(),
      dealType,
      offerType,
      pageType: 'Listing',
    });

    if (companionName) {
      urlSearchParams.set('companionName', encodeURIComponent(companionName));
    }

    if (cianUserId) {
      urlSearchParams.set('companionId', encodeURIComponent(cianUserId));
    }

    if (gaProducts) {
      urlSearchParams.set('gaProducts', encodeURIComponent(gaProducts));
    }

    if (gaLabel) {
      urlSearchParams.set('gaLabel', encodeURIComponent(gaLabel));
    }

    if (contextToken) {
      urlSearchParams.set('context', encodeURIComponent(contextToken));
    }

    return `/dialogs/?${urlSearchParams.toString()}`;
  }

  private get companionName(): string {
    const { offerHelper } = this.context;

    const userId = offerHelper.presenters.getCianUserId();
    const agencyName = offerHelper.presenters.getAgentName();

    return agencyName || `ID ${userId}`;
  }

  private readonly handleWriteMessageClick: VoidFunction = () => {
    const { disabled, isAuthorised, gaLabel } = this.props;

    if (!disabled) {
      const { tracking } = this.context.api;

      tracking.trackFirstMessageClick?.(gaLabel);

      if (isAuthorised === false) {
        this.props.onRequestAuthentication();
      } else {
        tracking.trackFirstMessageOpen?.(gaLabel);

        this.setState({ showChats: true });
      }
    }
  };

  private readonly handleClickOutside: VoidFunction = () => {
    this.setState({ showChats: false });
  };
}

function mapDispatchToProps(dispatch: Dispatch): IStartChatButtonDispatchProps {
  return {
    onRequestAuthentication: () => dispatch(requestAuthentication({ alert: EAlertType.Chats })),
  };
}

export const StartChatPopup = connect(null, mapDispatchToProps)(StartChatPopupComponent);
